/**
 * Abre el mega menú al pasar el mouse.
 *
 * Dawn lo abre solo con clic: <details>/<summary> más details-disclosure.js,
 * que únicamente escucha 'toggle'. En escritorio eso obliga a un clic para ver
 * las categorías y otro para ir a una.
 *
 * Esto no reemplaza el clic, lo complementa: se limita a poner y sacar el
 * atributo `open`, así que el `toggle` sigue disparando y HeaderMenu conserva
 * su lógica de aria-expanded, animaciones y posición del header.
 */
(() => {
  // Solo donde hay un puntero real. En táctil el hover es un fantasma que deja
  // menús abiertos sin forma de cerrarlos.
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer.matches) return;

  // Margen para que el puntero pueda viajar del título al panel sin que se
  // cierre en el camino.
  const CLOSE_DELAY = 180;

  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;

    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      if (details.hasAttribute('open')) return;
      // Un solo mega menú abierto a la vez.
      document.querySelectorAll('header-menu details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        // No cerrar si el teclado está adentro: se estaría peleando con el foco.
        if (details.contains(document.activeElement)) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);

    // Con el menú ya abierto por hover, el clic en el título navegaría a la
    // colección padre en vez de cerrarlo: dejamos que navegue, que es lo que
    // el visitante espera de un título que además es un enlace.
    summary.addEventListener('click', (event) => {
      const href = summary.dataset.href;
      if (!href) return;
      event.preventDefault();
      window.location.href = href;
    });
  });
})();
